import React from "react";
import {Col, Layout, Row, Space} from "antd";
import {NavLink} from "react-router-dom";
const {Footer} = Layout

const CustomFooter = () => {
    return (
        <Footer className="uk-background-default">
            <div className="uk-container uk-margin-top">
                <Row gutter={12}>
                    <Col span={8}>
                        <div>
                            <h4>
                                Food  delivery
                            </h4>
                            <p>
                                Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Donec odio. Quisque volutpat mattis eros
                            </p>
                            <h5 className="uk-h5">
                                © 2020. Все права защищены.
                            </h5>
                        </div>
                    </Col>
                    <Col span={4}>
                        <ul className="uk-list">
                            <li>
                                <h5>
                                    INFORMATION
                                </h5>
                            </li>
                            <li>
                                <NavLink to="/about" className="uk-link-text">
                                    About us
                                </NavLink>
                            </li>
                            <li>
                                <NavLink to="/policy" className="uk-link-text">
                                    Policy and privacy
                                </NavLink>
                            </li>
                            <li>
                                <NavLink to="/terms" className="uk-link-text">
                                    Terms and conditions
                                </NavLink>
                            </li>
                            <li>
                                <NavLink to="/jobs" className="uk-link-text">
                                    Jobs
                                </NavLink>
                            </li>
                        </ul>
                    </Col>
                    <Col span={4}>
                        <div>
                            <h5>
                                SOCIAL MEDIA
                            </h5>
                            <div>
                                <Space className="uk-margin-small-bottom">
                                    <a href="" className="uk-icon-button" uk-icon="twitter"/>
                                    <a href="" className="uk-icon-button" uk-icon="facebook"/>
                                    <a href="" className="uk-icon-button" uk-icon="google-plus"/>
                                </Space>

                                <br/>

                                <Space>
                                    <a href="" className="uk-icon-button" uk-icon="twitter"/>
                                    <a href="" className="uk-icon-button" uk-icon="facebook"/>
                                    <a href="" className="uk-icon-button" uk-icon="google-plus"/>
                                </Space>
                            </div>
                        </div>
                    </Col>
                    <Col span={4}>
                        <ul className="uk-list">
                            <li>
                                <h5>
                                    MOBILE APPS
                                </h5>
                            </li>
                            <li>
                                <a className="uk-link-text">
                                    iOS app
                                </a>
                            </li>
                            <li>
                                <a className="uk-link-text">
                                    Android app
                                </a>
                            </li>
                        </ul>
                    </Col>
                    <Col span={4}>
                        <ul className="uk-list">
                            <li>
                                <h5>
                                    BUSINESS
                                </h5>
                            </li>
                            <li>
                                <a className="uk-link-text">
                                    Login
                                </a>
                            </li>
                        </ul>
                    </Col>
                </Row>
            </div>
        </Footer>
    )
};
export default CustomFooter;



// WEBPACK FOOTER //
// ./src/Components/Layout/Footer.js